/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import React from 'react';
import { useAIThemeColor } from '@atlassian/generative-ai-modal/styles/theme';
export var Border = function Border() {
  var aiThemeColor = useAIThemeColor();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("stop", {
    stopColor: aiThemeColor('prism.border.step.1')
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.25",
    stopColor: aiThemeColor('prism.border.step.1')
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.41",
    stopColor: aiThemeColor('prism.border.step.2')
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.73",
    stopColor: aiThemeColor('prism.border.step.3')
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.86",
    stopColor: aiThemeColor('prism.border.step.4')
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: aiThemeColor('prism.border.step.4')
  }));
};